/** Older wizard articles have no separate SEO fields. Use their existing text as defaults. */
export function resolveArticleMetadata(article: {
  title?: string; subtitle?: string; metaTitle?: string; metaDescription?: string;
}): { metaTitle: string; metaDescription: string } {
  return {
    metaTitle: article.metaTitle?.trim() ? article.metaTitle : Array.from(article.title || '').slice(0, 100).join(''),
    metaDescription: article.metaDescription?.trim() ? article.metaDescription : Array.from(article.subtitle || '').slice(0, 100).join('')
  };
}
